import useModifiers from 'hooks/useModifiers';

export enum SpinnerModifier {
  SELECT = 'select',
  BG_TRANSPARENT = 'bg-transparent',
}

export interface SpinnerProps {
  dimensions?: number;
  modifiers?: SpinnerModifier[];
}

export default function Spinner(props: SpinnerProps) {
  const { dimensions = 64 } = props;
  const mods = useModifiers(props.modifiers);

  return (
    <div className={`ct_spinner ${mods}`}>
      <div className="ct_spinner-inner">
        <svg className="ct_spinner-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width={dimensions} height={dimensions} fill="none">
          <g>
            <defs>
              <linearGradient id="sGD" gradientUnits="userSpaceOnUse" x1="55" y1="46" x2="2" y2="46">
                <stop offset="0.1" stopColor="currentColor" stopOpacity="0" />
                <stop offset="1" stopColor="currentColor" stopOpacity="1" />
              </linearGradient>
            </defs>

            <g strokeWidth="3" strokeLinecap="round" stroke="currentColor" fill="none">
              <path stroke="url(#sGD)" d="M4,32 c0,15,12,28,28,28c8,0,16-4,21-9" />
              <path d="M60,32 C60,16,47.464,4,32,4S4,16,4,32" />

              <animateTransform values="0,32,32;360,32,32" attributeName="transform" type="rotate" repeatCount="indefinite" dur="2000ms" />
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
}

Spinner.defaultProps = { ...{} };
